<template>
  <div id="chart-line-item-item-box">
    <chart-title
        leftTitle="ASP排产监测 center_13"
        :rightTitle="`${formatTime(date, 'yyyy年MM月')}`"></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="center_13" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { planArea } from "@/api/cockpit/jyl";
import {formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "center_13",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),      //日期
      dayList: [],           //日期数据
      unPlannedList: [],     //未排产
      plannedList: [],       //已排产
      specialList: [],       //特效动画 未排产最高、已排产最高
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData() {
      //初始化
      this.dayList = [];
      this.unPlannedList = [];
      this.plannedList = [];
      this.specialList = [];

      planArea({
        date: getFirstDate(this.date, "yyyy-MM-dd"),
      }).then((resp) => {
        for(let item in resp.data){
          this.dayList.push(`${resp.data[item].day}日`);
          this.unPlannedList.push(resp.data[item].unplanned_area);
          this.plannedList.push(resp.data[item].planned_area);
        }
        //特效动画 未排产最高、已排产最高
        const maxUnPlanned = Math.max(...this.unPlannedList).toFixed(4); //未排产最高
        const maxplanned = Math.max(...this.plannedList).toFixed(4);     //已排产最高
        this.specialList.push(
            [
              this.dayList[this.unPlannedList.indexOf(maxUnPlanned.toString())],maxUnPlanned
            ],
            [
              this.dayList[this.plannedList.indexOf(maxplanned.toString())],maxplanned
            ])

        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_13"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: "2%",
          data: ["未排产", "已排产"],
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "10%",
          bottom: "17%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          data: this.dayList,
        },
        yAxis: {
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
          type: "value",
        },
        series: [
          {
            name: "未排产",
            type: "line",
            smooth: true,
            data: this.unPlannedList,
            color: "#009dff",
          },
          {
            name: "已排产",
            type: "line",
            smooth: true,
            data: this.plannedList,
            color: "#22e4ff",
          },
          {
            // 设置涟漪特效动画
            type: "effectScatter",
            coordinateSystem: "cartesian2d",
            data: this.specialList,
            symbolSize: 9,
            // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
            showEffectOn: "render",
            // 涟漪特效配置
            rippleEffect: {
              // 波纹的绘制方式,可选'stroke'和'fill'
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #center_13 {
    height: 100%;
  }
}
</style>
